import { Space, Button } from 'antd';
import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import DrawerWithAutoWidth from '../../../../../components/DrawerWithAutoWidth';
import AddCtsSettingsForm, { type CompanySpecsForCts } from './AddCtsSettingsForm';

export type CtsSettingsDrawerProps = {
    onClose: () => void;
    visible: boolean;
    moduleId: string;
    company: CompanySpecsForCts;
};

const CtsSettingsDrawer = ({ onClose, visible, moduleId, company }: CtsSettingsDrawerProps) => {
    const { t } = useTranslation(['ctsModuleDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>{t('ctsModuleDetails:settings.create.cancelButton')}</Button>
                    <Button form="addCtsSettings" htmlType="submit" type="primary">
                        {t('ctsModuleDetails:settings.create.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('ctsModuleDetails:settings.create.title')}
            visible={visible}
            destroyOnClose
        >
            <AddCtsSettingsForm company={company} moduleId={moduleId} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default CtsSettingsDrawer;

export const useCtsSettingsDrawer = (moduleId: string, company: CompanySpecsForCts) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => (
            <CtsSettingsDrawer company={company} moduleId={moduleId} onClose={actions.close} visible={visible} />
        ),
    };
};
